import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";
import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpg';
import banner3 from '../assets/banner3.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/banner5.jpg';
import banner6 from '../assets/banner6.jpg';
import banner7 from '../assets/banner7.jpg';
import { 
  IoServer, IoConstruct, IoLaptopOutline, IoPeopleOutline, IoCall, 
  IoShieldCheckmarkOutline, IoSyncOutline, IoFlashOutline, IoSchoolOutline, 
  IoSearchOutline, IoLockClosedOutline, IoCardOutline, IoGlobeOutline 
} from "react-icons/io5";
import { GiCheckMark } from "react-icons/gi";
import logo from '../assets/logo.png';
import AOS from 'aos';
import 'aos/dist/aos.css';


export default function HomeBanner1(props) {

		const activities = [
	{
		icon: <IoServer size={28} />,
		title: "Fiber Optical Network",
		desc: "Design, installation, testing, and maintenance of fiber networks."
	},
	{
		icon: <IoConstruct size={28} />,
		title: "Preventive & Corrective Maintenance",
		desc: "Ensuring IT and telecom systems run efficiently and reliably."
	},
	{
		icon: <IoLaptopOutline size={28} />,
		title: "Network Infrastructure",
		desc: "LAN/WAN planning, design, and implementation."
	},
	{
		icon: <IoPeopleOutline size={28} />,
		title: "Business Management Solutions",
		desc: "Streamlined solutions to enhance operational efficiency."
	},
	{
		icon: <IoCall size={28} />,
		title: "ICT & Telecom Consultancy",
		desc: "Expert advice for IT strategy, telecoms, and infrastructure."
	},
	{
		icon: <IoServer size={28} />,
		title: "Voice Systems",
		desc: "IP/Analog voice system installation and maintenance."
	},
	{
		icon: <IoLaptopOutline size={28} />,
		title: "Computer Sales & Accessories",
		desc: "Supply of computers, peripherals, and accessories."
	},
	{
		icon: <IoShieldCheckmarkOutline size={28} />,
		title: "Intruder & Fire Alarm Systems",
		desc: "Design, installation, and maintenance of security systems."
	},
	{
		icon: <IoSyncOutline size={28} />,
		title: "Systems Integration & Migration",
		desc: "Seamless integration and migration of IT and telecom systems."
	},
	{
		icon: <IoFlashOutline size={28} />,
		title: "Power Backup & Surge Protection",
		desc: "Installation and maintenance for uninterrupted operations."
	},
	{
		icon: <IoSchoolOutline size={28} />,
		title: "ICT Training Services",
		desc: "Professional and end-user training programs."
	},
	{
		icon: <IoSearchOutline size={28} />,
		title: "Audit & Review",
		desc: "Assessment and improvement of current IT infrastructure."
	},
	{
		icon: <IoLockClosedOutline size={28} />,
		title: "ICT Standards & Security",
		desc: "Policies, strategies, and ICT controls for secure operations."
	},
	{
		icon: <IoCardOutline size={28} />,
		title: "Smart Card Solutions",
		desc: "Design and implementation of electronic ID and access systems."
	},
	{
		icon: <IoGlobeOutline size={28} />,
		title: "Web Solutions",
		desc: "Web design, development, domain registration, and hosting."
	},
	];

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);
	const [ bgIndex, setBgIndex ] = useState(0);
	const banners = [banner5, banner7, banner1, banner2, banner3, banner4, ];

	async function init() {
		setReady(false);
		// initializations...
		setReady(true);
	}
	

	useEffect(() => {
		init();
	}, []);
	
	useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: false,
    });
  }, []);

	// Background transition effect
	useEffect(() => {
		if (!ready) return;

		const interval = setInterval(() => {
			setBgIndex(prev => (prev + 1) % banners.length);
		}, 2500); // change every 5 seconds

		return () => clearInterval(interval);
	}, [ready]);

	if (ready) {
		return (
			<div className="MainBodySection">
				<div
					style={{
						width: "100%",
						height: "auto",
						position: "relative",
						overflow:"auto"
					}}
				>
					{banners.map((banner, i) => (
						<div
							key={i}
							style={{
								backgroundImage: `url(${banner})`,
								backgroundAttachment: "fixed",
								backgroundSize: "cover",
								backgroundPosition: "center",
								width: "100%",
								height: "100%",
								position: "absolute",
								top: 0,
								left: 0,
								transition: "opacity 1.5s ease-in-out",
								opacity: i === bgIndex ? 1 : 0,
							}}
						/>
					))}

					{/* gradient overlay */}
					<div
						style={{
							width: "100%",
							height: "100%",
							background: "rgba(0, 0, 0, 0.5)",
							position: "relative",
							zIndex: 1
						}}
					>
						<div className="container py-5">
							<div className="row g-4">
								<div className="col-md-12">
									<div className="main-section-title text-primary">
										Company Activities
									</div>
									<h6 className="text-light font-semi-bold">
										FIMACY Company LTD specializes in professional IT, Telecoms & Network solutions, designed to empower businesses with reliable and secure infrastructure.
									</h6>
								</div>
								{activities.map((item, index) => (
								<div key={index} className="col-md-4 d-flex">
									<div className="bg-light rounded p-4 flex-grow-1 d-flex flex-column align-items-start">
									<div className="mb-3 text-secondary">
										{item.icon}
									</div>
									<h5 className="font-bold text-secondary">{item.title}</h5>
									<p className="mt-2 mb-0" style={{ fontWeight: 400 }}>
										{item.desc}
									</p>
									</div>
								</div>
								))}
							</div>
							</div>
						</div>
					</div>

				</div>
		);
	} else {
		return (
			<div className="container mSupportLoading">
				{getInlineLoader()}
			</div>
		);
	}
}
